import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import LoaderPage from "../../../../layouts/loader-page/loader-page";
import { Button, DataGrid } from "devextreme-react";
import { Column, Editing, Item, Lookup, Toolbar } from "devextreme-react/cjs/data-grid";
import { getPropsDataGrid } from "../../../../utils/default-props";
import { useDataSource } from "../../../../contexts/dataSource";
import useAxiosPrivate, { axiosHrPrivate } from "../../../../api/useAxios";
import { getDataGridCustomToolbarCaption } from "../../../../components/default-components/data-grid-custom-toolbar";
import { EmploymentDocumentCheckListAddTemplate } from "./employment-document-checklist-template.tsx";

export function EmploymentDocumentCheckList({ employeeId }) {
    const { dataSourceHR } = useDataSource()
    const axiosPrivate = useAxiosPrivate(axiosHrPrivate)
    const [formData, setFormData] = useState([
        {
            "employeeId": "0a5cdcf0-bcb2-471b-9374-031c86ccdb99",
            "employeeDocumentInfoId": "632c7a42-42b7-462a-b277-7bf8e78f382c",
            "approvalStatus": false,
            "id": "fe18ba11-2a6f-455a-b9e6-d3015b4d29f3"
        },
        {
            "employeeId": "5fc6588b-8775-4ca9-a79e-b4bac86159f6",
            "employeeDocumentInfoId": "c4d84981-aae5-4998-b38b-70e8a7e0327a",
            "approvalStatus": true,
            "id": "95eb907a-7460-416b-922a-ad8b72abe67c"
        }
    ])
    const [documentInfos, setDocumentInfos] = useState(undefined)
    const [templateVisible, setTemplateVisible] = useState(false)
    const [loading, setLoading] = useState(false)
    const dataGridRef = useRef()

    const dataSource = useMemo(() => dataSourceHR({
        loadUrl: `/api/EmployeeCheckList/Employee/${employeeId}`,
        insertUrl: "/api/EmployeeCheckList/FormData",
    }), [dataSourceHR])

    const dbDocumentInfo = useMemo(() => dataSourceHR({
        loadUrl: "/api/EmployeeDocumentInfo"
    }), [dataSourceHR])

    const documentInfoEditorOptions = useMemo(() => (
        {
            dataSource: dbDocumentInfo,
            valueExpr: "id",
            displayExpr: "name",
        }
    ), [dbDocumentInfo])

    // const affinityOption = {
    //     items: documentInfos ,
    //     valueExpr: "id",
    //     displayExpr: "text"
    // }
    // useEffect(() => {
    //     try {
    //         axiosPrivate.get(`/api/EmployeeDocumentInfo`)
    //             .then((response) => {
    //                 if (response?.status === 200)
    //                     if (response.data?.data) {
    //                         let documentInfoList = response.data?.data.map((item) => {
    //                             return {
    //                                 id: item.id,
    //                                 name: item.name
    //                             }
    //                         })
    //                         setDocumentInfos(documentInfoList)
    //                     }
    //             })
    //             .catch((error) => console.log(error))
    //     } catch (error) {
    //         console.log(error)
    //     }
    // }, [])

    const templateHiding = useCallback(() => {
        setTemplateVisible(false)
    }, [])

    const handleSablondanEkle = useCallback(() => {
        setTemplateVisible(true)
    }, [])

    const onInitNewRow = useCallback((e) => {
        e.data.employeeId = employeeId
        e.data.approvalStatus = true
    }, [employeeId])

    const addFromTemplate = useCallback((selecttedTemplate) => {

        if (!selecttedTemplate) return
        console.log("selecttedTemplate", selecttedTemplate)
        selecttedTemplate.employeeDocumentInfos.forEach(item => {

            (async function () {
                console.log("item", item)
                let data = { values: "" };

                data.values = JSON.stringify({
                    employeeId: employeeId,
                    employeeDocumentInfoId: item.id,
                    approvalStatus: false
                })

                const axiosOptions = {
                    method: "post",
                    url: "/api/EmployeeCheckList/FormData",
                    data: data
                }
                try {
                    const result = await axiosPrivate(axiosOptions);
                    if ((result.status = 200) || (result.status = 201)) {
                        dataGridRef.current.instance.refresh()
                    }

                } catch (error) {
                    console.log(error);// mükerrer kayıtların atlansın
                }
            })();
        });

    }, [])


    return (
        <React.Fragment>
            <div className="dx-form-group-caption">İşe Giriş Evrakları </div>
            <DataGrid
                {...getPropsDataGrid}
                dataSource={dataSource}
                width={600}
                onInitNewRow={onInitNewRow}
                ref={dataGridRef}
            >
                <Editing
                    allowDeleting={true}
                    allowAdding={true}
                />
                <Toolbar>
                    {getDataGridCustomToolbarCaption("Getirilecek Evraklar")}
                    <Item name="addRowButton" />

                    <Item location='after'>
                        <Button icon='importselected' hint="Şablondan ekle" onClick={handleSablondanEkle} />
                    </Item>
                    {/* <Item location='after'>
                        <Button icon='importselected' onClick={() => setMultiAddPopup(true)} />
                    </Item>                    
                     */}
                </Toolbar>

                <Column dataField="id" caption="ID" visible={false} />
                <Column
                    caption="Döküman"
                    dataField="employeeDocumentInfoId"

                // editorType="dxSelectBox"
                //  editorOptions={documentInfoEditorOptions}
                >
                    <Lookup dataSource={dbDocumentInfo} valueExpr="id" displayExpr="name" />

                </Column>

                <Column dataField="approvalStatus" caption="Onay Durumu" editorType="dxCheckBox" width={150} />

            </DataGrid>
            {templateVisible
                &&
                <EmploymentDocumentCheckListAddTemplate
                    visible={templateVisible}
                    setVisible={setTemplateVisible}
                    onHiding={templateHiding}
                    addFromTemplate={addFromTemplate}
                />
            }

        </React.Fragment>
        //<LoaderPage loading={false}>

        //</LoaderPage>


    )
}